<template>
  <div class="page-container">
    <div class="backbtn-container">
      <router-link to="/my-office">
        <div class="back-btn mr-3">
          <v-icon class="pointer-events-none">mdi-arrow-left</v-icon>
        </div>
      </router-link>
      <span class="p-0">{{ this.departmentName[`name_${$i18n.locale}`] }}</span>
    </div>
    <div class="table-container">
      <div class="actions_container">
        <div class="attach-btn-container">
          <v-btn
            style="text-transform: capitalize; font-weight: normal"
            color="primary"
            class="add_product_btn"
            @click="openAttachProductModel"
            v-if="permissions.OFFICE_PRODUCT_ATTACH_DEPARTMENT"
          >
            {{ this.$t("attachProduct") }}
          </v-btn>
          <div class="resPersonContainer">
            <span class="leaderText">{{ this.$t("resPerson") }}</span>
            <span class="leaderValue">{{ this.departmentName.leader }}</span>
          </div>
        </div>

        <v-btn
          class="export-exel"
          variant="outlined"
          style="color: #0096b2"
          v-if="permissions.OFFICE_PRODUCT_EXPORT_EXCEL_DEPARTMENT"
          @click="exportExcel"
          :loading="excelExportLoading"
        >
          {{ this.$t("exportExel") }}
        </v-btn>
      </div>
      <div>
        <table-with-filter
          style="width: 100%"
          :is-filterable="false"
          fixed-header
          :height="$vuetify.breakpoint.height - 160"
          hide-default-footer
          :headers="headers"
          :items="departmentProducts"
        >
          <template #item.attached="{ item }">
            <span class="badge" :class="{ badgeSuccess: item.attached }">{{
              item.attached ? $t("available") : $t("no")
            }}</span>
          </template>
          <template #item.actions="{ item }">
            <VTooltip color="#fff" left nudge-right="10" nudge-top="35">
              <template v-slot:activator="{ on, attrs }">
                <VBtn
                  v-if="permissions.OFFICE_PRODUCT_DELETE_DEPARTMENT"
                  v-bind="attrs"
                  v-on="on"
                  class="new_style"
                  @click="$refs.contractEditDialog.open(item)"
                >
                  <vue-icon icon="newTrashIcon" />
                </VBtn>
              </template>
              <span>{{ $t("edit") }}</span>
            </VTooltip>
          </template>
        </table-with-filter>
      </div>
    </div>
    <v-dialog v-model="attachProductDialog" max-width="400px">
      <div class="model_container">
        <span>
          <span class="title">{{ this.$t("attachProduct") }}</span>
          <div @click="closeModal">
            <vue-icon
              icon="newBoldCloseIcon"
              style="cursor: pointer"
            ></vue-icon>
          </div>
        </span>
        <ValidationObserver ref="observer">
          <form @submit.prevent="attachProductSubmit" style="width: 100%">
            <div class="modalForm">
              <label>
                {{ this.$t("categoryProduct") }}
                <ValidationProvider
                  rules="required"
                  name="categoryProductPr"
                  v-slot="{ errors }"
                >
                  <vue-select
                    :class="{ errorSelect: !!errors[0] }"
                    infinite
                    ref="ProductSelectRef"
                    @CHANGE_VALUE="categorySelect"
                    :name="$t('categoryProduct')"
                    :placeholder="$t('categoryProduct')"
                    @item-resolved="setCategoryList"
                    :get-item-promise="
                      ({ text, page }) =>
                        getCategoryList({ name: text, page, limit: 15 })
                    "
                    v-model="categoryId"
                    :items="categoryList"
                    clearable
                    :itemText="`name_${$i18n.locale}`"
                    class="user_input no-margin"
                    style="flex-grow: 1"
                  ></vue-select>
                </ValidationProvider>
              </label>
              <label>
                {{ this.$t("selectProduct") }}
                <ValidationProvider
                  rules="required"
                  name="selectProductPr"
                  v-slot="{ errors }"
                >
                  <vue-select
                    :class="{ errorSelect: !!errors[0] }"
                    ref="ProductSelectRef"
                    :name="$t('selectProduct')"
                    :placeholder="$t('selectProduct')"
                    @item-resolved="setProductList"
                    :disabled="!categoryId"
                    :get-item-promise="
                      ({ text, page }) =>
                        getProductList({ name: text, page, limit: 15 })
                    "
                    v-model="attachProductData.productId"
                    :items="productList"
                    clearable
                    itemText="name"
                    class="user_input no-margin"
                    style="flex-grow: 1"
                  ></vue-select>
                </ValidationProvider>
              </label>
              <label>
                {{ this.$t("quantityProducts") }}
                <ValidationProvider
                  :name="`${$t('quantityProducts')}`"
                  rules="required|min_value:1"
                  v-slot="{ errors }"
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                  "
                >
                  <input
                    type="number"
                    v-model="attachProductData.count"
                    :class="{ errorInput: !!errors[0] }"
                    placeholder="0"
                  />
                  <span class="error-text">{{ errors[0] }}</span>
                </ValidationProvider>
              </label>
              <v-btn
                type="submit"
                color="primary"
                class="add btn"
                :loading="isLoading"
              >
                {{ this.$t("add") }}
              </v-btn>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </v-dialog>
    <DepartmentEditDialog
      :departmentData="departmentName"
      @saved="getAllDepartmentProducts"
      ref="contractEditDialog"
    />
  </div>
</template>

<script>
import VueSelect from "../../../../components/ui/vue-select/VueSelect.vue";
import TableWithFilter from "../../../../components/ui/table/TableWithFilter.vue";
import DepartmentEditDialog from "../../../../components/myOffice/DepartmentEditDialog.vue";

export default {
  components: { DepartmentEditDialog, VueSelect, TableWithFilter },
  data() {
    return {
      permissions: {},
      excelExportLoading: false,
      isLoading: false,
      attachProductDialog: false,
      categoryId: null,
      attachProductData: {
        productId: null,
        count: null,
        departmentId: this.$route.params.departmendId,
      },
      departmentProducts: [],
      categoryList: [],
      productList: [],
      departmentProductParams: {
        page: 0,
        limit: 10,
      },
      departmentName: {
        name_uz: "",
        name_ru: "",
        name_en: "",
        leader: "",
      },
      msg: "title for while..",
    };
  },
  methods: {
    downloadBlobFile: (file, fileName) => {
      const a = document.createElement("a");
      document.body.appendChild(a);
      a.style.display = "none";
      const url = window.URL.createObjectURL(file);
      a.href = url;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);
      setTimeout(() => a.remove());
    },
    async exportExcel() {
      try {
        this.excelExportLoading = true;
        const { data } = await this.$http.get(
          `office-product-item/export-excel/${this.$route.params.departmendId}`,
          {
            responseType: "blob",
          }
        );

        this.downloadBlobFile(
          data,
          `${this.departmentName[`name_${this.$i18n.locale}`]}.xlsx`
        );
      } catch (e) {
        console.log(e);
      } finally {
        this.excelExportLoading = false;
      }
    },
    async categorySelect() {
      await this.getProductList();
    },
    async setCategoryList(data) {
      this.categoryList = data;
    },
    setProductList(data) {
      this.productList = data;
    },
    async openAttachProductModel() {
      if (!this.categoryList.length) {
        await this.getCategoryList();
      }

      this.attachProductDialog = true;
    },
    async getCategoryList(params) {
      try {
        const {
          data: { data },
        } = await this.$http.get(`product-type/list`, {
          params: {
            forOffice: true,
            ...params,
          },
        });
        this.categoryList = data;

        return {
          data,
        };
      } catch (e) {
        console.log(e);
      }
    },
    async getProductList(params) {
      try {
        const { data } = await this.$http.get("office-product/list", {
          params: {
            categoryId: this.categoryId,
            ...params,
          },
        });
        this.productList = data.data;
        return {
          data: data.data,
        };
      } catch (e) {
        console.log(e);
      }
    },
    async getAllDepartmentProducts() {
      this.showLoading();
      try {
        const { data } = await this.$http.get(
          `office-product/by-department/${this.$route.params.departmendId}`,
          {
            params: this.departmentProductParams,
          }
        );

        this.departmentProducts = data.data.items;
        this.departmentName = data.data.department;
        this.permissions = data.permissions;
      } catch (e) {
        console.log(e);
      } finally {
        this.clearLoading();
      }
    },
    async attachProductSubmit() {
      this.$refs.observer.validate().then(async (success) => {
        if (success) {
          this.showLoading();
          this.isLoading = true;
          try {
            await this.$http.post(
              "office-product/attach",
              this.attachProductData
            );
            await this.getAllDepartmentProducts();
            this.$refs.observer.reset();
            this.attachProductDialog = false;
            this.attachProductData = {
              productId: null,
              count: null,
              departmentId: this.$route.params.departmendId,
            };
            this.categoryId = null;
          } catch (e) {
            console.log(e);
            this.$notify({ text: e.response.data.error, type: "error" });
          } finally {
            this.clearLoading();
            this.isLoading = false;
          }
        }
      });
    },
    closeModal() {
      this.attachProductDialog = false;
      this.$refs.observer.reset();
    },
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("name"),
          value: "name",
        },
        {
          text: this.$t("productCharacteristics"),
          value: "description",
        },
        {
          text: this.$t("count"),
          value: "count",
        },
        {
          text: this.$t("attachedToEmployee"),
          value: "attached",
        },
        {
          text: this.$t("action"),
          value: "actions",
        },
      ];
    },
  },
  async created() {
    await this.getAllDepartmentProducts();
  },
};
</script>

<style lang="scss" scoped>
.model_container {
  background-color: #fff;
  padding: 24px;

  span {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .modalForm {
    display: flex;
    flex-direction: column;
    gap: 18px;
    margin-top: 20px;

    input {
      width: 100%;
    }
  }
}

input,
textarea {
  background-color: #fafbfc;
  border-radius: 5px;
  border: 1px solid #dfe2e9;
  outline: none;
  padding: 6px;
}

.errorInput {
  border-color: red;
  -webkit-box-shadow: inset 3px 0px 63px -31px rgba(255, 0, 0, 0.355);
  -moz-box-shadow: inset 3px 0px 63px -31px rgba(255, 0, 0, 0.355);
  box-shadow: inset 3px 0px 63px -31px rgba(255, 0, 0, 0.355);
}

.error-text {
  height: 10px;
  font-size: 12px;
  color: red;
  font-family: "Rubik", sans-serif;
  margin-top: 5px;
}

.backbtn-container {
  display: flex;
  align-items: center;
  gap: 3px;
}

.back-btn {
  background-color: #fff;
  border-radius: 6px;
  display: inline-block;
  padding: 4px;
  transition: 0.4s ease;
  border: 1px solid #dfe2e9;
  box-shadow: 0px 1px 2px 0px #0e31581a;

  &:hover {
    border-color: #0096b2;
  }
}

.actions_container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 24px;

  .generation_box {
    display: flex;
    align-items: center;
    gap: 15px;

    p {
      font-family: "Rubik", sans-serif;
      font-size: 12px;
      font-style: italic;
      font-weight: 400;
      line-height: 14.22px;
      color: #a2a5b9;
    }
  }
}

.table-container {
  background-color: #fff;
  border-radius: 6px;
  padding: 24px;
  margin-top: 24px;
}

.badge {
  border-radius: 6px;
  padding: 8px 10px;
  background-color: #e3e6eb;
  color: #647182;

  &.badgeSuccess {
    background-color: #a2f6a0;
    color: #178015;
  }
}

.leaderText {
  font-family: "Rubik", sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 14.22px;
  color: #7a889b;
}

.leaderValue {
  font-family: "Rubik", sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 18.96px;
  color: #48545d;
}

.attach-btn-container {
  display: flex;
  align-items: center;
  gap: 20px;
}

.resPersonContainer {
  display: flex;
  flex-direction: column;
  gap: 5px;
  border-left: 2px solid #dfe2e9;
  padding-left: 20px;
}
</style>
